import React from "react";
import styled from "styled-components";
import { HashLink as Hlink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faWpforms } from '@fortawesome/free-brands-svg-icons'
import { ContainerWrapper, FlexCenter, SectionHeader } from "../../../Components/Utils";

const IconWrapper = styled.span`
  display: block;
  color: hsl(217,40%,45%);
`;
const FlexContainer = styled(FlexCenter)`
  width: 100%;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
const FlexChild = styled(FlexCenter)`
  flex-direction: column;
  flex: 1;
  margin-bottom: 15px;
  @media (min-width: 700.1px) {
    ${props => props.pTop ? `padding-top: 32px;` : ''}
  }
`;
const FlexChildText = styled.div`
  @media (min-width: 700.1px) {
    height: 178px;
  }
`;
const FlexChildAddress = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center; 
  flex: 1;  
`;
function ContactDetail () {
  return (
    <ContainerWrapper textAlign="justify">
      <p>Have questions? Send us an email or fill out the form. You may also want to check out our <Link to="/faq">FAQ page</Link> for answers</p>
      <SectionHeader weight="light" mt="1rem" mb="2.5rem">Ways to reach us</SectionHeader>
      <FlexContainer>
        <FlexChild>
        <IconWrapper>
          <FontAwesomeIcon icon={faEnvelope} size="3x" />
        </IconWrapper>
          <SectionHeader size="light" weight="light" mt="1rem" mb="1rem">
            Email us
          </SectionHeader>
          <div>
          <a href="mailto:info@globalgers.co">info@globalgers.co</a>
          </div>
        </FlexChild>        
        <FlexChild>
          <IconWrapper>
            <FontAwesomeIcon icon={faWpforms} size="3x" />
          </IconWrapper>
          <SectionHeader size="light" weight="light" mt="1rem" mb="1rem">
            Join us
          </SectionHeader>
          <div>
          <Hlink to="/joinus/#form">Fill out a form here</Hlink>
          </div>
        </FlexChild>
        <FlexChild pTop={true}>
        <IconWrapper>
        <a href="https://www.google.ca/maps/place/7+Bayview+Rd,+Ottawa,+ON+K1Y+3B5/@45.4096895,-75.7302203,17z/data=!3m1!4b1!4m5!3m4!1s0x4cce0441d4558e01:0x68c5b9a6731b105e!8m2!3d45.4096858!4d-75.7280263" title="Click to open in google map" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faMapMarkerAlt} size="3x" /></a>
        </IconWrapper>
          <SectionHeader size="light" weight="light" mt="1rem" mb="1rem">
            Locate us
          </SectionHeader>
          <FlexChildAddress>
            <small>c/o Carleton University</small>
            <small>7 Bayview Road</small>
            <small>Ottawa, Ontario K1Y 3B5</small>   
          </FlexChildAddress>
        </FlexChild>
      </FlexContainer>
    </ContainerWrapper>
  );
}

export default ContactDetail



// WEBPACK FOOTER //
// ./src/Pages/Misc/Components/Contact.js